import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { ProductList } from './pages/ProductList';
import { ProductDetail } from './pages/ProductDetail';
import { SyncDashboard } from './pages/SyncDashboard';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="app">
          <header className="app-header">
            <div className="header-content">
              <h1 className="logo">PromoAtlas</h1>
              <nav className="main-nav">
                <a href="/products" className="nav-link">Products</a>
                <a href="/sync-dashboard" className="nav-link">Sync Status</a>
              </nav>
            </div>
          </header>

          <main className="app-main">
            <Routes>
              <Route path="/" element={<Navigate to="/products" replace />} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/sync-dashboard" element={<SyncDashboard />} />
            </Routes>
          </main>

          <footer className="app-footer">
            <div className="footer-content">
              <p>&copy; 2025 PromoAtlas PIM. All rights reserved.</p>
            </div>
          </footer>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
